import { SunIcon } from '@trippath/shared';
import { useTranslation } from 'react-i18next';

import { DAYLIGHT, NOON, SUNRISE, SUNSET, SunMark } from '../../components/icons/SunIcons';
import { minutesSaid } from '../../lib/clock';
import type { SkyDay } from '../../lib/sky';

/**
 * The sun of a day at the stop, shortly, each part marked and said in words when pointed at:
 * its rise and set, when it stands highest, how long the day is light — `↑ 06:36–17:55 ↓ ·
 * ☀ 12:16 · ⧗ 11 h 19 min`; under the midnight sun or in the polar night, so said.
 */
export function SunLine({ sky }: { sky: SkyDay }) {
  const { t } = useTranslation();
  if (sky.sunrise === null || sky.sunset === null) {
    return (
      <p className="day-sun-said">
        <SunIcon size={18} />
        {t(sky.daylight > 0 ? 'calendar.sunUp' : 'calendar.sunDown')}
      </p>
    );
  }
  return (
    <p className="day-sun-said">
      <SunMark d={SUNRISE} said={t('calendar.sunrise')} />
      <span className="mono">
        {sky.sunrise}–{sky.sunset}
      </span>
      <SunMark d={SUNSET} said={t('calendar.sunset')} />
      <span className="day-sun-gap" aria-hidden="true">
        ·
      </span>
      <SunMark d={NOON} said={t('calendar.solarNoon')} />
      <span className="mono">{sky.solarNoon}</span>
      <span className="day-sun-gap" aria-hidden="true">
        ·
      </span>
      <SunMark d={DAYLIGHT} said={t('calendar.daylight')} />
      <span>{minutesSaid(sky.daylight)}</span>
    </p>
  );
}
